// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"60b93e81","253":"ce6396a9","554":"256614ce"}[chunkId] + ".chunk.css";
};